import { detectCountry, type SupportedCountry } from './countryDetection';
import type { CampingSpot } from '../types';

const COUNTRY_FLAG: Record<SupportedCountry, string> = {
  NO: '🇳🇴',
  SE: '🇸🇪',
  DK: '🇩🇰',
  FI: '🇫🇮',
};

/** Landet en plass ligger i, utledet fra koordinater (eller null hvis ukjent). */
export function spotCountry(spot: CampingSpot): SupportedCountry | null {
  if (!spot.location) return null;
  const { latitude, longitude } = spot.location;
  if (typeof latitude !== 'number' || typeof longitude !== 'number') return null;
  return detectCountry(latitude, longitude);
}

/**
 * Bygger "kommune, fylke"-etiketter for en liste plasser. Landflagg legges kun
 * til når plassene spenner over flere land (f.eks. både Norge og Sverige), slik
 * at en ren norsk liste slipper støy.
 */
export function buildSpotLocationLabels(spots: CampingSpot[]): Record<string, string> {
  const countryById = new Map<string, SupportedCountry>();
  for (const s of spots) {
    const c = spotCountry(s);
    if (c) countryById.set(s.id, c);
  }
  const showCountry = new Set(countryById.values()).size > 1;

  const labels: Record<string, string> = {};
  for (const s of spots) {
    const parts = [s.municipality, s.county].filter(Boolean) as string[];
    let label = parts.join(', ');
    if (showCountry) {
      const flag = COUNTRY_FLAG[countryById.get(s.id) as SupportedCountry];
      if (flag) label = label ? `${flag} ${label}` : flag;
    }
    labels[s.id] = label;
  }
  return labels;
}
